module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "center-1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/summer"
    }
  }, [_vm._v("Summer: 1978")])]), _vm._v(" "), _c('p', {
    staticClass: "center-1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01"
    }
  }, [_vm._v("one")])]), _vm._v(" "), _c('p', {
    staticClass: "center-1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter02"
    }
  }, [_vm._v("two")])]), _vm._v(" "), _c('p', {
    staticClass: "center-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("three")])]), _vm._v(" "), _c('p', {
    staticClass: "center-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("four")])]), _vm._v(" "), _c('p', {
    staticClass: "center-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("five")])]), _vm._v(" "), _c('p', {
    staticClass: "center-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("six")])]), _vm._v(" "), _c('p', {
    staticClass: "center-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("seven")])]), _vm._v(" "), _c('p', {
    staticClass: "center-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("eight")])]), _vm._v(" "), _c('p', {
    staticClass: "center-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("nine")])]), _vm._v(" "), _c('p', {
    staticClass: "center-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ten")])]), _vm._v(" "), _c('p', {
    staticClass: "center-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("eleven")])]), _vm._v(" "), _c('p', {
    staticClass: "center-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("twelve")])]), _vm._v(" "), _c('p', {
    staticClass: "center-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("thirteen")])]), _vm._v(" "), _c('p', {
    staticClass: "center-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("fourteen")])]), _vm._v(" "), _c('p', {
    staticClass: "center-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("fifteen")])]), _vm._v(" "), _c('p', {
    staticClass: "center-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("sixteen")])]), _vm._v(" "), _c('p', {
    staticClass: "center-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("seventeen")])]), _vm._v(" "), _c('p', {
    staticClass: "center-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("eighteen")])]), _vm._v(" "), _c('p', {
    staticClass: "center-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("nineteen")])]), _vm._v(" "), _c('p', {
    staticClass: "center-1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Preview",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preview: "), _c('i', [_vm._v("When Last Seen Alive")])])]), _vm._v(" "), _c('p', {
    staticClass: "center-1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/acknowledgement",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53e656ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/content.vue
// module id = 75
// module chunks = 0